import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'app/shared/services/api.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-add',
  templateUrl: './add.component.html',
  styleUrls: ['./add.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,

})
export class AddComponent implements OnInit {

  classForm:FormGroup
  class_model={
      userIds: [],
      topic: '',
      date: new Date(),
      time: 'Attendence mark before 4pm',
      batchId: ''
  }
  student_list=[]
  select_student=null
  batch_list=[]
  select_batch=null
  course_list=[]
  select_course=null

  topic_list=[]
  select_topic=null

  currentUrl:any
  class_id:any
  user:any
  constructor(private formBuilder: FormBuilder,public toastr: ToastrService, 
    private activerouter: ActivatedRoute,public apiService: ApiService,
    private route: Router,) { 
      this.currentUrl = this.activerouter.snapshot.routeConfig.path
                this.user=JSON.parse(localStorage.getItem('user'))
                this.activerouter.paramMap.subscribe(params => {
                  this.class_id = params.get('id');
                })
    }

  ngOnInit(): void {
    this.classForm = this.formBuilder.group({
      topic : ['',],
      date : [''],
      time :[''],
    })
   if(this.user?.roles ==='admin'){
    this.getBatchList()
    this.getCourseList()
   }
   if(this.user?.roles ==='employee'){
    this.getBatchByIntstructor(this.user?.id)
    this.getCourseList()
  }
  if(this.class_id){
    this.classGetById(this.class_id)
  }
  }
  get rf() {
    return this.classForm.controls;
  }
  getBatchByIntstructor(id){
    this.apiService.getBatchListByInstructor(id).subscribe((res:any)=>{
     this.batch_list = res?.data?.items
     this.course_list = res?.data?.items[0]?.course_id
     this.select_batch = res?.data?.items[0]?._id
     this.select_course = res?.data?.items[0]?.course_id[0]?._id
     if(this.select_batch && this.select_course){
      this.getStudentListByBatchId(this.select_batch,this.select_course)
      this.getTopicList(this.select_course)
     }
    })
  }
  classGetById(id){
    this.apiService.getClassById(id).subscribe((res:any)=>{
      this.class_model.topic = res?.data?.topic
      this.class_model.date = res?.data?.date
      this.class_model.time = res?.data?.time
      this.select_batch = res?.data?.batchId?._id
      this.class_model.batchId = this.select_batch
      this.select_student = res?.data?.userIds.map(item =>item._id)
      this.class_model.userIds = this.select_student
      if(res?.data?.topic){
        this.select_topic = res?.data?.topic?.map(item =>item._id)
        this.class_model.topic =  this.select_topic
      }
    
        // this.select_course = res?.data?.batchId?.course_id
        // this.class_model.topic =  this.select_topic

    })
  }
  getBatchList(){
    this.apiService.getBatchList(1,100).subscribe((res:any)=>{
      this.batch_list= res?.data?.items
    })
  }
  getCourseList(){
    this.apiService.getCourseList(1,100).subscribe((res:any)=>{
      this.course_list= res?.data?.items
    })
  }
  getBatchId(event){
    this.select_batch
    if(event.course_id){
      this.select_course = event?.course_id[0]?._id?event?.course_id[0]?._id:event?.course_id?._id
      if(this.select_course){
        this.getStudentListByBatchId(this.select_batch,this.select_course)
        this.getTopicList(this.select_course)
      }
      
    }
    else this.toastr.error('course not found!')
  }
  getCourseId(event){
    this.select_course
    this.getStudentListByBatchId(this.select_batch,this.select_course)
    this.getTopicList(this.select_course)
  }
  getStudentListByBatchId(batchId,courseId){
    this.apiService.getStudentByBatchCourseId(batchId,courseId).subscribe((res:any)=>{
      if(res.statusCode===200){
        this.student_list = res?.data
        if(this.student_list.length<1){
          this.toastr.error('student not found!')
        }
        this.select_student = this.student_list.map(item=>item?.user_id)
      }
    })
  }
  getStudentId(event){
    this.select_student
  }
  getTopicId(event){
    this.select_topic    
  }
  getTopicList(id){
    this.apiService.getTopicsByCourseId(id).subscribe((res:any)=>{
      if(res.statusCode === 200){
        const extractedData = res?.data.map((item) => {
          return item.data.flatMap((subArray) => {
            return subArray.flatMap((innerArray) => {
              return innerArray.map((obj) => {
                return {
                  name: obj.name,
                  _id: obj._id
                };
              });
            });
          });
        });
        this.topic_list = extractedData.flat()

      }
    })
  }
  submit(){
    if(this.currentUrl==='add'){
      let body={
        batchId: this.select_batch,
        userIds: this.select_student,
        topic: this.select_topic,
        date: this.classForm.value.date,
        time: this.classForm.value.time,
      }
      this.apiService.createClass(body).subscribe((res:any)=>{
        if(res.statusCode===200){
          this.toastr.success(res.message)
          this.route.navigate(['/classes/list'])
        }
        else{
          this.toastr.error(res.error)
        }
      })
    }
    if(this.currentUrl ==='edit/:id'){
      this.class_model.batchId = this.select_batch 
      this.class_model.userIds = this.select_student
      this.apiService.updateClass(this.class_id,this.class_model).subscribe((res:any)=>{
        if(res.statusCode===200){
          this.toastr.success(res.message)
          this.route.navigate(['/classes/list'])
        }
        else{
          this.toastr.error(res.error)
        }
      })
    }
    
  }
  back(){
    this.route.navigate(['/classes/list'])
  }
 
}
